<template>
  <div class="typeform-edit">
    <style-bar :css-keys="['background', 'color']" class="mb-2" mode="text" :styles.sync="localStyles"></style-bar>
    <div class="form-ctn pt-3">

      <v-text-field class="py-2 px-4" hide-details :placeholder="$t('typeformedit_contact_us')" v-model="form.content" :label="$t('button_text')"></v-text-field>
      <!-- <v-text-field  persistent-hint v-model="form.url" hint="Eg: https://scantrust.typeform.com/to/XXXXX" label="Typeform URL"></v-text-field> -->
      <rich-text-input class="px-4 pt-5" :placeholder="$t('typeformedit_typeform_url_placeholder')" :content.sync="form.url" mode="url" :json.sync="urlContentJson" :label="$t('typeformedit_typeform_url')"></rich-text-input>
      <v-radio-group class="py-2 px-4" v-model="form.mode">
        <v-radio :label="$t('automatic')" value="scroll"></v-radio>
        <span class="font-weight-light pl-8 pb-2">{{$t('typeformedit_automatic_description')}}</span>
        <v-radio :label="$t('manual')" value="manual"></v-radio>
        <span class="font-weight-light pl-8 pb-2">{{$t('typeformedit_manual_description')}}</span>
      </v-radio-group>
    </div>
  </div>
</template>

<script>

import RichTextInput from '@/components/utils/RichTextInput'
import StyleBar from '@/components/utils/StyleBar'

export default {
  name: 'TypeformEdit',
  props: ['content', 'url', 'mode', 'styles'],
  components: {
    RichTextInput,
    StyleBar
  },
  data () {
    return {
      form: {
        content: '',
        url: '',
        mode: 'manual'
      },
      urlContentJson: {},
      localStyles: {}
    }
  },
  created () {
    this.form.content = this.content

    if (typeof this.form.content !== 'string') {
      this.form.content = ''
    }
    this.form.url = this.url
    if (!this.mode) {
      this.form.mode = 'manual'
    } else {
      this.form.mode = this.mode
    }

    if (this.styles) {
      this.localStyles = JSON.parse(JSON.stringify(this.styles))
    }
  }
  // methods: {
  //   updateContent () {
  //     this.$emit('update:content', this.btnContent)
  //   },

  //   updateUrl () {
  //     this.$emit('update:url', this.btnUrl)
  //   }
  // }
}
</script>

<style lang="sass" scoped>

.typeform-edit
  background: #f1f1f1
  .form-ctn
    background: white

</style>
